"use client"
import * as turf from "@turf/turf";

import "@/components/shared/DistanceView.css";

const DistanceView = ({
  from,
  to,
  units = "miles",
  displayUnits = "mi",
  suffix
}) => {

  if (from && to) {
    var mapLink = null;
    var options = { units: units };

    var distance = turf.distance(from, to, options);
    if (distance < 1) {
      if (units === "miles") {
        distance = Math.floor(distance * 5280);
        displayUnits = "feet";
      }
    } else {
      // floor of distance
      distance = Math.floor(distance);
    }
    return (
      <>
        <span>
          {`${distance} ${displayUnits}${suffix ? ` ${suffix}` : ""}`}
        </span>
      </>
    );
  } else {
    return <></>;
  }
};
export default DistanceView;
